module.exports = __webpack_public_path__ + "img/member-01.da335798.png";